export function calculateNetworkInterfacesAliases(networkInterfaces) {
    if (networkInterfaces && networkInterfaces.length > 0) {
        return networkInterfaces.reduce((alias, networkInterface) => {
            alias[networkInterface.name] = networkInterface.description;
            return alias;
        }, {});
    }
    return undefined;
}
